import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { CustomerAppModule } from './app/customer-app.module';

platformBrowserDynamic()
  .bootstrapModule(CustomerAppModule)
  .catch((err) => console.error(err));
